module.exports = __webpack_public_path__ + "img/dcu.df81b554.svg";